import { useState } from "react";

const FAQS = [
  {
    q: "71吃瓜主要整理哪些内容？",
    a: "我们聚焦娱乐圈里的跨圈联动、跨界合作与“串门”互动，把相关的爆料、路透与后续进展收在一条时间线上，方便你在同一处看清来龙去脉，而不是在不同平台上东拼西凑。",
  },
  {
    q: "“联动瓜”和“串门瓜”有什么区别？",
    a: "联动通常指两个或多个圈子、作品或团队之间正式的合作互动，例如影综联动、双导演接力；串门则更像一位熟面孔在别的节目或舞台上短暂客串亮相。我们都会单独归类、配上进度更新。",
  },
  {
    q: "为什么要把跨圈瓜放在同一条线上整理？",
    a: "跨圈事件往往牵涉多方粉丝与多个平台，散落的信息很难看全。把来路、影响与后续更新并排摆出来，能帮助你快速理清人物关系与事件因果，减少因信息差导致的误读和争吵。",
  },
  {
    q: "吃瓜时如何避免被带节奏？",
    a: "我们建议先看信息来源是否可追溯（官微、片方、正规媒体），再看多方说法是否一致，最后再下结论。本站每则爆料都会标注来源口径，把“实锤”“路透”与“猜测”分开呈现。",
  },
  {
    q: "我发现了新的联动或串门线索，如何提供给71吃瓜？",
    a: "欢迎通过页面底部订阅与联系表单告诉我们。投稿请尽量附上可核实的时间、平台与原始出处，我们整理时会优先采用有来源、可回溯的信息，并克制使用未经证实的内容。",
  },
];

export default function GuideSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-10 md:py-14">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" /> FAQ
            </p>
            <h2 className="mt-2 font-display text-2xl text-foreground-900 md:text-3xl">
              吃瓜指南
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于“怎么吃瓜、怎么站队、怎么投稿”，这里有最常被问到的问题与我们的回答。吃得明白，才不会被带跑偏。
            </p>
            <div className="mt-6 rounded-2xl border border-background-200 bg-background-100/50 p-5">
              <p className="flex items-center gap-2 font-medium text-foreground-900">
                <i className="ri-lightbulb-flash-line text-secondary-600" /> 小编提醒
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                吃瓜归吃瓜，保持边界很重要。涉及个人隐私、未经证实的人身评价，我们一律谨慎处理，愿每个瓜都吃得理性又开心。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {FAQS.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={f.q}
                  className="overflow-hidden rounded-2xl border border-background-200 bg-background-100/50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                    aria-expanded={isOpen}
                  >
                    <span className="flex items-center gap-3 font-medium text-foreground-900">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-400 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      } ${isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[60px] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[68px]">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}